<!-- <div class="header"></div> -->
<div class="site-container">
    <app-ui-layout-header></app-ui-layout-header>
    <div class="policy-content">
        <div class="policy-content-head">Kişisel Verilerin Korunma Kanunu</div>
        <b>Veri Sorumlusu : </b><br><b>Milliyet Gazetecilik ve Yayıncılık A.Ş.</b><br>
        100.Yıl Mahallesi, 2264 Sokak, Demirören Medya Center, No: 1/51 34204
        Bağcılar, İstanbul / Türkiye
        <br><br>
        <b>Milliyet Gazetecilik ve Yayıncılık A.Ş.</b> (Bundan sonra “<b>Milliyet</b>” veya “<b>Şirket</b>” olarak
        anılacaktır.) olarak 6698
        sayılı Kişisel Verilerin Korunması Kanunu (“<b>KVKK</b>”) ve ilgili mevzuat kapsamında <b>Heykelde Yeni
            Keşifler</b>
        yarışmasına katılımınız doğrultusunda kişisel verilerinizin işlenmesi, saklanması ve aktarılması ile ilgili siz
        yarışmacılara bilgi vermek amacıyla işbu aydınlatma metnini hazırladık.
        <br><br>
        <b>1. Hangi Kişisel Verileriniz İşlenmektedir?</b><br>
        <b>Heykelde Yeni Keşifler yarışmasına</b> katılım kapsamında;<br>

        Başvuru formu aracılığıyla, yarışma başvuru/seçim/sergi süreçlerinin ve iletişim faaliyetlerinin yürütülmesi
        amaçları doğrultusunda;<br>
        <ul>
            <li><b>Kimlik Bilgileri (ad, soyad, doğum tarihi),</b></li>
            <li><b>İletişim Bilgileri (e-posta, telefon numarası, adres ve web adresi)</b> ve</li>
            <li><b>Katıldığınız Sergi Bilgileri</b> ile <b>Eser Bilgileri</b> ve</li>
        </ul>
        Kişisel Verilerin Korunması Kanunu madde 5/2 fıkra (c) gereğince bir sözleşmenin kurulması ve ifasıyla doğrudan
        doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması hukuki
        nedenine dayanılarak işlenmektedir.
        <br><br>
        <b>2. Kişisel Verileriniz Kimlere ve Hangi Amaçlarla Aktarılabilecektir?</b><br>
        Kişisel verileriniz,
        <ul>
            <li>Yarışma başvuru ve seçim süreçlerinin yürütülmesi kapsamında başvuru yapılan platformun sağlanması ile
                yarışma süreçlerinin yürütülmesi amaçları doğrultusunda Tedarikçiler’e,
            </li>
            <li>Yarışma başvuru, seçim ve sonuç süreçlerinin yürütülmesi kapsamında Seçici Kurul Üyeleri’ne</li>
            <li>İş faaliyetleri ve lojistik faaliyetlerinin yürütülmesi ile yarışma sonucunda serginin düzenlenmesi
                amaçlarıyla sınırlı olarak Topluluk Şirketleri (Kemer Country)’ne,
            </li>
            <li>Yetkili kamu kurum ve kuruluşlara bilgi verilmesi ve faaliyetlerin mevzuata uygun yürütülmesi amaçları
                doğrultusunda Yetkili Kamu Kurum ve Kuruluşları’na aktarılmaktadır.
            </li>
        </ul>
        <br>
        ** Yarışma sonucunda dereceye giren eserler ad ve soyad bilginizle birlikte kamuya açık ”Heykelde Yeni Keşifler”
        sergisinde kamuoyuna sunulacaktır.
        <br><br>
        ** Yarışma kapsamında paylaştığınız eserleriniz ad ve soyad bilginizle birlikte basılı ve görsel medyada,
        dijital ve sosyal mecralarda aleni olarak yer alacaktır.
        <br><br>
        <b>3. Kişisel Verileriniz Ne Kadar Süre ile Saklanır?</b><br>
        Kişisel verileriniz, kanunda veya ilgili mevzuatta verinin saklanması için bir süre belirlenmişse, söz konusu
        veri en az bu süre kadar saklanmak zorundadır. Kanunda veya ilgili mevzuatta bir süre öngörülmemişse; işlenme
        amaçlarıyla bağlantılı, sınırlı ve ölçülü olmak kaydıyla belirlenen makul sürelerce saklanmaktadır.
        <br><br>
        <b>4. İlgili Kişi Olarak Kişisel Verilerinize İlişkin Haklarınız Nelerdir?</b><br>
        Kişisel verilerinize ilişkin;
        <ul>
            <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
            <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
            <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
            <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme,</li>
            <li>KVKK mevzuatında öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini
                isteme,
            </li>
            <li>Eksik veya yanlış verilerin düzeltilmesi ile kişisel verilerinizin silinmesi veya yok edilmesini talep
                ettiğinizde, bu durumun kişisel verilerinizi aktardığımız üçüncü kişilere bildirilmesini isteme,
            </li>
            <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi
                aleyhine bir sonucun ortaya çıkmasına itiraz etme ve
            </li>
            <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde bu zararın
                giderilmesini talep etme,
            </li>
        </ul>
        haklarına sahipsiniz.
        <br><br>
        <b>5. İlgili Kişi Olarak Haklarınızı Nasıl Kullanabilirsiniz?</b><br>
        Kişisel verileriniz ile ilgili başvuru ve taleplerinizi dilerseniz İlgili Kişi Başvuru Formu aracılığıyla;<br>
        <ul>
            <li>Daha önce Milliyet’e bildirmiş olduğunuz e-posta adresiniz aracılığıyla <a
                    href="mailto:kvkkbasvuru@milliyet.com.tr">kvkkbasvuru@milliyet.com.tr</a>
                adresine elektronik posta göndererek,
            </li>
            <li>Geçerli bir kimlik belgesi ile bizzat başvurarak,</li>
            <li>Islak imzalı ve kimlik fotokopisi ile 100.Yıl Mahallesi, 2264 Sokak, Demirören Medya Center, No: 1/51
                34204 Bağcılar, İstanbul / Türkiye adresine göndererek,
            </li>
            <li>Mobil imza veya güvenli elektronik imza ile imzalayıp <a
                    href="mailto:kvkkbasvuru@milliyet.com.tr">kvkkbasvuru@milliyet.com.tr</a> adresine e-posta
                göndererek,
            </li>
            <li>Kayıtlı elektronik posta (KEP) adresi ve güvenli elektronik imza ya da mobil imza kullanmak suretiyle
                <a href="mailto:milliyetgazetecilik@hs03.kep.tr">milliyetgazetecilik@hs03.kep.tr</a> kayıtlı elektronik
                posta (KEP) adresine göndererek,
            </li>
        </ul>
        <b>Milliyet</b>’e iletebilirsiniz.
        <br><br>
        Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ uyarınca, İlgili Kişi’nin, başvurusunda isim, soyisim,
        başvuru yazılı ise imza, T.C. kimlik numarası (başvuruda bulunan kişinin yabancı olması halinde uyruğu, pasaport
        numarası veya varsa kimlik numarası), tebligata esas yerleşim yeri veya iş yeri adresi, varsa bildirime esas
        elektronik posta adresi, telefon numarası ve faks numarası ile talep konusuna dair bilgilerin bulunması
        zorunludur.
        <br><br>
        İlgili Kişi, yukarıda belirtilen hakları kullanmak için yapacağı ve kullanmayı talep ettiği hakka ilişkin
        açıklamaları içeren başvuruda talep edilen hususu açık ve anlaşılır şekilde belirtmelidir. Başvuruya ilişkin
        bilgi ve belgelerin başvuruya eklenmesi gerekmektedir.
        <br><br>
        Talep konusunun başvuranın şahsı ile ilgili olması gerekmekle birlikte, başkası adına hareket ediliyor ise
        başvuruyu yapanın bu konuda özel olarak yetkili olması ve bu yetkinin belgelendirilmesi (vekâletname)
        gerekmektedir. Ayrıca başvurunun kimlik ve adres bilgilerini içermesi ve başvuruya kimliği doğrulayıcı
        belgelerin eklenmesi gerekmektedir.
        <br><br>
        Yetkisiz üçüncü kişilerin başkası adına yaptığı talepler değerlendirmeye alınmayacaktır.
        <br><br>
        <b>6. Kişisel Verilerinizin İşlenmesine İlişkin Talepleriniz Ne Kadar Sürede Cevaplanır?</b><br>
        Kişisel verilerinize ilişkin talepleriniz değerlendirilerek, <b>Milliyet</b>’e ulaştığı tarihten itibaren en
        kısa
        sürede ve en geç 30 gün içinde cevaplandırılır. Talebinizin kabul edilmesi veya gerekçesi açıklanarak
        reddedilmesi halinde cevabımız başvuruda belirttiğiniz adrese posta veya elektronik posta yolu başta olmak üzere
        eğer mümkünse talebinizin yapıldığı usulle size iletilir.
    </div>
</div>
<!-- <div class="footer">
</div> -->